import ServerApp from '~/modules/core/ServerApp';
import '~/assets/fonts/fonts.css';
import '~/assets/App.css';
import '~/assets/RichText.css';

export default ServerApp;
